<script>
export default {
  name: "IconWhiteChevronRight"
};
</script>

<template>
  <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.73 8.62L2.4 15.74a.92.92 0 01-1.28 0l-.85-.83a.86.86 0 010-1.24L6.06 8 .26 2.33a.86.86 0 010-1.24l.85-.83c.35-.35.93-.35 1.28 0l7.34 7.12a.86.86 0 010 1.24z"
      fill="currentColor"
    />
  </svg>
</template>
